import { Button, Modal } from "antd";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import { FaPrint } from "react-icons/fa";
import { HiOutlineBackspace } from "react-icons/hi";
import { IoDocumentAttachOutline } from "react-icons/io5";
import numberToWords from "../../../../../Components/NumberToWords/NumberToWords";
export default function PrintAble({
  setDriverModal,
  setIsModalOpen,
  selectedOne,
  setSelectedDriver,
  selectedDriver,
}) {
  let elementRef = useRef();
  const handlePrint = () => {
    const printContent = elementRef.current;
    const WinPrint = window.open("", "", "width=900,height=900");

    WinPrint.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          @media print {
            @page {
              margin: 0 10mm;
            }
            body {
              margin: 0;
              
              font-family: Arial, sans-serif;
            }
          }
        </style>
      </head>
      <body>${printContent.innerHTML}</body>
    </html>
  `);

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };
  function formatDate(inputDate) {
    // Month names in Uzbek
    const uzbekMonths = [
      "январ",
      "феврал",
      "март",
      "апрел",
      "май",
      "июн",
      "июл",
      "август",
      "сентябр",
      "октябр",
      "ноябр",
      "декабр",
    ];

    // Split the input date (dd.mm.yyyy) into day, month, and year
    const [day, month, year] = inputDate.toString().split(".");

    // Convert to Uzbek format
    const formattedDate = `${year} йил ${parseInt(day, 10)} ${
      uzbekMonths[parseInt(month, 10) - 1]
    }`;

    return formattedDate;
  }
  useEffect(() => {
    console.log(selectedOne);
    console.log("selectedDriver");
    console.log(selectedDriver);
  }, []);

  return (
    <Modal
      style={{ top: "10px", width: "100vw" }}
      title="Xaydovchi Biriktirish"
      width="100%"
      open={true}
      //   loading={loadVagon}
      onOk={() => {
        // setIsModalOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setDriverModal(false);
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setDriverModal(false);
          }}
          style={{ backgroundColor: "#f5222d", color: "#fff" }}
        >
          Yopish
        </Button>,
      ]}
    >
      {/* z-[100] absolute */}
      <div className="bold-text  m-auto  w-[100%] pt-4 top-0 bottom-0 right-0 left-0 bg-[#fff]">
        <div className="max-w-[900px] w-[100%] m-auto pb-[30px]">
          <div className="flex flex-row items-center justify-between">
            {" "}
            <Button
              onClick={() => {
                handlePrint();
              }}
              variant="solid"
              icon={<FaPrint className="font-[30px]" />}
            >
              Print
            </Button>
            <div>
              {/* <Button
                onClick={() => {
                  setDriverModal(false);
                }}
                variant="solid"
                icon={<HiOutlineBackspace className="font-[30px]" />}
              ></Button> */}
              <Button
                onClick={() => {
                  setDriverModal(false);
                  setIsModalOpen(true);
                }}
                icon={<IoDocumentAttachOutline />}
              />
            </div>
          </div>
          <div
            ref={elementRef}
            style={{
              width: "100%",
              fontSize: "16px",
              fontWeight: "bold",
              fontFamily: "times new roman bold",
              fontWeight: "bold",
              fontStyle: "normal",
            }}
          >
            {/* <h2
              style={{
                textAlign: "center",
                fontSize: "12px",
                paddingTop: "50px",
                fontFamily: "times new roman bold",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "underline",
                paddingTop: "100px",
              }}
            >
              2024 йил 4 март кунги №38-5/07-OB сонли ваколатли омборда минерал
              ўғитларни сақлаш шартномасига асосан
            </h2> */}
            <h3
              style={{
                textAlign: "center",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              " MINERAL MARKET " MЧЖ Уйчи тумани № 111 - омборидан жўнатиш{" "}
            </h3>
            <h3
              style={{
                textAlign: "center",
                fontSize: "17px",
                fontWeight: 600,
              }}
            >
              ЙЎЛ ВАРАҚАСИ{" "}
            </h3>
            <p
              style={{
                textAlign: "center",
                fontSize: "16px",
                fontWeight: 600,
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  paddingRight: "15px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                № {selectedOne?.ykx?.ykx}
              </span>{" "}
              сонли{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {formatDate(
                  moment(selectedOne?.ykx?.date).format("DD.MM.YYYY")
                )}
              </span>
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: "16px",
                paddingLeft: "15px",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  paddingRight: "15px",
                }}
              >
                Етказиб берувчи хабарномаси: № {selectedOne?.habarnoma?.id}
              </span>{" "}
              сонли{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                }}
              >
                {formatDate(
                  moment(selectedOne?.habarnoma?.date).format("DD.MM.YYYY")
                )}
              </span>
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: "16px",
                paddingLeft: "15px",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  paddingRight: "15px",
                }}
              >
                Ташувчи:
              </span>{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {selectedDriver?.name} ( ИНН {selectedDriver?.INN} )
              </span>
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: "16px",
                paddingLeft: "15px",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  paddingRight: "15px",
                }}
              >
                Етказиб берувчи:
              </span>{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                АО "Ammofos-Maxam" ( STIR: 200599579 )
              </span>
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: "16px",
                paddingLeft: "15px",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  paddingRight: "15px",
                }}
              >
                Юк қабул қилувчи:
              </span>{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                }}
              >
                {selectedOne?.name} ИНН: {selectedOne?.INN}
              </span>
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: "16px",
                paddingLeft: "15px",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  paddingRight: "15px",
                }}
              >
                {formatDate(
                  moment(selectedOne?.ticket?.date).format("DD.MM.YYYY")
                )}
              </span>{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                }}
              >
                № {selectedOne?.ticket.ticket} сонли олди-сотди шартнома
              </span>
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: "16px",
                paddingLeft: "15px",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  paddingRight: "15px",
                }}
              >
                {formatDate(
                  moment(selectedOne?.believer?.date).format("DD.MM.YYYY")
                )}
              </span>{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                }}
              >
                № {selectedOne?.believer?.id} сонли Ишончнома
              </span>
            </p>
            <p
              style={{
                textAlign: "right",
                paddingRight: "80px",
                fontSize: "16px",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  paddingRight: "15px",
                  fontWeight: "bold",
                }}
                className="bold-text"
              >
                TURAYEV M{" "}
              </span>{" "}
              <span
                style={{
                  paddingLeft: "15px",
                  fontSize: "16px",
                  fontStyle: "italic",
                  fontFamily: "times new roman bold",
                  fontWeight: "bold",
                }}
                className="bold-text "
              >
                оркали
              </span>
            </p>
            {/* table here */}
            <div
              style={{
                marginLeft: "15px",
                marginRight: "15px",
              }}
            >
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                }}
                border="1"
                className="text-[16px]"
                cellpadding="10"
              >
                <tr>
                  <th
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      textAlign: "center",
                    }}
                  >
                    №
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      margin: 0,
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                  >
                    Юк номи
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                  >
                    Ўлчов бирлиги
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                  >
                    Тара
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                  >
                    Брутто
                  </th>
                  <th
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                  >
                    Нетто
                  </th>
                </tr>
                <tr
                  style={{
                    fontSize: "16px",
                    margin: 0,
                  }}
                >
                  <td
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: "20px",
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    1
                  </td>
                  <td
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: "10px",
                      paddingLeft: "10px",
                      lineHeight: "16px",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    {selectedOne?.product}
                  </td>
                  <td
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "16px",
                      padding: "4px",
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    Tn
                  </td>
                  <td
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: "4px",
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    {selectedDriver?.tara}
                  </td>
                  <td
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: "4px",
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    {selectedOne?.tonna +
                      (selectedDriver?.tara ? selectedDriver?.tara : 0)}
                  </td>
                  <td
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "16px",
                      padding: "4px",
                      textAlign: "center",
                    }}
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    {selectedOne?.tonna}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "16px",
                      padding: "20px",
                      textAlign: "center",
                    }}
                  >
                    X
                  </td>
                  <td
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "16px",
                      padding: "4px",
                      textAlign: "center",
                    }}
                    colspan="3"
                  >
                    Жами:{" "}
                  </td>
                  <td
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "16px",
                      padding: "4px",
                      textAlign: "center",
                    }}
                  >
                    X
                  </td>
                  <td
                    className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    style={{
                      fontSize: "16px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "16px",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {selectedOne?.tonna}
                  </td>
                </tr>
              </table>
              <p
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "5px",
                  justifyContent: " space-between",
                  fontSize: "17px",
                  fontFamily: "times new roman bold",
                  fontWeight: "bold",
                  fontStyle: "normal",
                }}
              >
                <span
                  style={{
                    fontSize: "17px",
                  }}
                >
                  Жами миқдори :{" "}
                  <span style={{ textDecoration: "underline" }}>
                    {numberToWords(selectedOne?.tonna * 1000)} кг
                  </span>
                </span>{" "}
                <span
                  style={{
                    display: "inline-block",
                    fontSize: "17px",
                    borderBottom: "1px",
                    borderColor: "#000",
                  }}
                ></span>{" "}
                <span
                  style={{
                    fontSize: "17px",
                  }}
                >
                  Қоп сони:{" "}
                  <span style={{ textDecoration: "underline" }}>
                    {(selectedOne?.tonna * 1000) / 50} дона{" "}
                  </span>
                </span>
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "10px",
                paddingTop: "30px",
                fontFamily: "times new roman bold",
                fontWeight: "bold",
                fontStyle: "normal",
              }}
            >
              <div>
                <p
                  style={{
                    fontSize: "16px",
                    fontFamily: "times new roman bold",
                    fontWeight: "bold",
                    fontStyle: "normal",
                  }}
                >
                  Юкни чиқарди{" "}
                </p>
                <p
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Сақловчи "Mineral- Market"
                </p>
                <p
                  style={{
                    fontSize: "16px",
                  }}
                >
                  MЧЖ ______________ А.Парпиев
                </p>
              </div>
              <div
                style={{
                  fontFamily: "times new roman bold",
                  fontWeight: "bold",
                  fontStyle: "normal",
                }}
              >
                <p
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Юкни қабул қилди:
                </p>
                <p
                  style={{
                    fontSize: "16px",
                  }}
                >
                  {selectedOne?.name}
                </p>
                <p
                  style={{
                    fontSize: "16px",
                  }}
                >
                  ______________ {selectedOne?.believer?.name}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
